export default __webpack_public_path__ + "static/media/element_11.a2f3a196.jpg";